import { createContext, useContext } from 'react';

export type CoinwebContextType = {
  address: string | null;
  isConnected: boolean;
  connect: () => Promise<void>;
  disconnect: () => void;
  isConnecting: boolean;
};

export const CoinwebContext = createContext<CoinwebContextType>({
  address: null,
  isConnected: false,
  connect: () => Promise.resolve(),
  disconnect: () => {},
  isConnecting: false,
});

export const useCoinwebWalletContext = () => useContext(CoinwebContext);
